import { default as BaseButton } from '@mui/joy/Button';
import ButtonGroupContext from '@mui/joy/ButtonGroup/ButtonGroupContext';
import { forwardRef, useContext, type JSX } from 'react';
import type { ToggleButtonGroupSizes } from '../../types';
import type { ToggleGroupButtonProp } from './types';
import { getButtonGroupButtonClassName } from './styles';
import { buttonGroupIconSizeMap } from './utils';

const ButtonGroupButton = forwardRef<HTMLButtonElement, ToggleGroupButtonProp>(
  (props, ref): JSX.Element => {
    const {
      size: sizeProp,
      color = 'neutral',
      startDecoratorComponent: StartDecoratorComponent,
      startDecoratorNode,
      endDecoratorComponent: EndDecoratorComponent,
      endDecoratorNode,
      className,
      selected,
      disabled = false,
      ...rest
    } = props;
    const buttonGroup = useContext(ButtonGroupContext);

    const size: ToggleButtonGroupSizes = sizeProp ?? buttonGroup.size ?? 'md';

    const iconSize = buttonGroupIconSizeMap[size];

    const startDecorator = StartDecoratorComponent ? (
      <StartDecoratorComponent height={iconSize} width={iconSize} />
    ) : (
      startDecoratorNode
    );

    const endDecorator = EndDecoratorComponent ? (
      <EndDecoratorComponent height={iconSize} width={iconSize} />
    ) : (
      endDecoratorNode
    );

    const buttonClassName = getButtonGroupButtonClassName({
      className,
      size,
      selected,
      disabled,
      color,
    });

    return (
      <BaseButton
        ref={ref}
        {...rest}
        className={buttonClassName}
        disabled={disabled}
        endDecorator={endDecorator}
        startDecorator={startDecorator}
      />
    );
  },
);

ButtonGroupButton.displayName = 'ButtonGroupButton';

export default ButtonGroupButton;
